export class NoContent extends Error {
  constructor(message) {
    super(message);
    this.name = "NoContent";
  }
}

export class ErrorBrowser extends Error {
  constructor(message) {
    super(message);
    this.name = "ErrorBrowser";
  }
}